import React, { Component } from 'react'
import debounce from 'lodash.debounce'
import { Wrapper, StyledFormInput } from './MobileStudentInfoRow.styles'
import { colors } from 'modules/dashboard/Home/Dashboard.global.styles'

export default class StudentInfoRow extends Component {
  constructor (props) {
    super(props)

    this.onInputChange = this.onInputChange.bind(this)
    this.debouncedInputChange = debounce(this.onInputChange, 500)
  }

  onInputChange (target) {
    this.props.setStudentState({
      _id: this.props.info._id,
      field: target.name,
      value: target.value
    })
  }

  render () {
    const { info, isEditMode, isParent } = this.props

    const commonProps = {
      placeholderColor: isEditMode ? colors.grey : colors.orange,
      backgroundColor: isEditMode ? null : colors.lightPurple,
      inputColor: isEditMode ? null : colors.white,
      noBorder: !isEditMode,
      focusColor: colors.orange,
      backgroundFocusColor: colors.lightOrange,
      element: 'button',
      disabled: !isEditMode,
      autoComplete: 'off',
      narrow: true,
      textSize: '15px',
      fieldNameSize: '18px',
      inputOpacity: info.stagedForDeletion ? '0.2' : '1'
    }

    return (
      <Wrapper>
        {/* autofill fix */}
        <input
          value='autofix'
          onChange={() => {}}
          name='username'
          placeholder='Username'
          hidden
        />
        {/* autofill fix */}
        <StyledFormInput
          {...commonProps}
          value={info.username}
          onChange={(e) => this.debouncedInputChange(e.target)}
          name='username'
          placeholder='Username'
          width='140px'
          customValidator={{
            test: async (e) => {
              const isValid = await this.props.isValidUsername(e, info._id)
              return isValid
            },
            errorMessage: 'Username taken or invalid',
            preSubmit: true
          }}
          required
        />
        <StyledFormInput
          {...commonProps}
          value={info.password}
          onChange={(e) => this.debouncedInputChange(e.target)}
          name='password'
          placeholder='••••••••••'
          placeholderColor={isEditMode ? colors.grey : colors.white}
          width='140px'
          type='password'
          validations='minLength:4'
          validationError='Password too short'
        />
      </Wrapper>
    )
  }
}
